module.exports = __webpack_public_path__ + "static/media/homepage-small.30023444.png";